// extracted by mini-css-extract-plugin
export default {"productButton":"ButtonBuy_productButton__4x4mj"};